export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1564659907532-6b5f98c8e70f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxyaW8lMjBkZSUyMGphbmVpcm8lMjBjaHJpc3QlMjByZWRlZW1lcnxlbnwwfHx8fDE3ODgzOTExMTV8MA&ixlib=rb-4.1.0&q=85",
  cristo:
    "https://images.unsplash.com/photo-1683331404237-64c763c70f5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxyaW8lMjBkZSUyMGphbmVpcm8lMjBjaHJpc3QlMjByZWRlZW1lcnxlbnwwfHx8fDE3ODgzOTExMTV8MA&ixlib=rb-4.1.0&q=85",
  paoDeAcucar:
    "https://images.unsplash.com/photo-1551620832-e2af54f6f0b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxwYW8lMjBkZSUyMGFjdWNhciUyMHN1Z2FybG9hZiUyMG1vdW50YWluJTIwcmlvJTIwZGUlMjBqYW5laXJvfGVufDB8fHx8MTc4ODM5MTEwN3ww&ixlib=rb-4.1.0&q=85",
  copacabana:
    "https://images.unsplash.com/photo-1710378481474-b15055551004?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjb3BhY2FiYW5hJTIwYmVhY2glMjByaW98ZW58MHx8fHwxNzg4MzkxMTE1fDA&ixlib=rb-4.1.0&q=85",
  darlei: "/images/darlei.jpg",
  selaron: "/images/selaron.jpg",
  arcosLapa: "/images/arcos-lapa.jpg",
  donaMartaSunrise: "/images/dona-marta-sunrise.jpg",
  donaMartaSunset: "/images/dona-marta-sunset.jpg",
  parqueLage: "/images/parque-lage.jpg",
  praiaVermelha: "/images/praia-vermelha.jpg",
  arpoador: "/images/arpoador.jpg",
};
